const composeRoutes = (...routes: string[]) => {
  return routes.join('/');
};

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RoutingUtils {
  export enum Routes {
    AUTHENTICATION = 'autenticacion',
    LOGIN = 'login',
    SUSCRIPTION = 'suscription-exitosa',
    FAILED = 'failed',
    SESSION = 'session-expired',
    INCOMPATIBLE = 'incompatible'
  }

  export const AtRoot = (route: string) => `/${ route }`;

  export const DashboardRoutes = {
    AUTHENTICATION: `${ composeRoutes(Routes.AUTHENTICATION) }`,
    SUSCRIPTION: `${ composeRoutes(Routes.SUSCRIPTION) }`,
    FAILED: `${ composeRoutes(Routes.FAILED) }`,
    SESSION: `${composeRoutes(Routes.SESSION)}`,
    INCOMPATIBLE: `${ composeRoutes(Routes.INCOMPATIBLE) }`
  } as const;
}

export function isMobile() {
  return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/.test(navigator.userAgent)
}
